module.exports = __webpack_public_path__ + "static/img/xiazailuyin.713cc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiazailuyin.png
// module id = ulki
// module chunks = 24